import React, { createContext, useContext, useMemo } from "react";

const ApplicationContext = createContext({
  applicationName: "",
});

export const useApplication = () => useContext(ApplicationContext);

function ApplicationContextProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const applicationName = process.env.NEXT_PUBLIC_APPLICATION ?? "quote";
  const value = useMemo(
    () => ({
      applicationName,
    }),
    [applicationName]
  );

  return (
    <ApplicationContext.Provider value={value}>
      {children}
    </ApplicationContext.Provider>
  );
}

export default ApplicationContextProvider;
